// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
// import VueResource from 'vue-resource'
import router from "./router";
import Vuelidate from "vuelidate";
import i18n from "../src/lang/i18n";
import VueMaterial from "vue-material";
import store from "./store/store";
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
import fontawesome from "@fortawesome/fontawesome";
import FontAwesomeIcon from "@fortawesome/vue-fontawesome";
import brands from "@fortawesome/fontawesome-free-brands";
import regular from "@fortawesome/fontawesome-free-regular";
import solid from "@fortawesome/fontawesome-free-solid";
import * as VueGoogleMaps from "vue2-google-maps";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueCarousel from "vue-carousel";
import jsPDF from "jspdf";
import VueTheMask from "vue-the-mask";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import ViewmedStyle from "../src/assets/sass/viewmed.css";
import Cropper from "../node_modules/cropperjs/dist/cropper.css";
import "../node_modules/fullpage.js/vendors/scrolloverflow"; // Optional. When using scrollOverflow:true
//import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from "vue-fullpage.js";
var SocialSharing = require("vue-social-sharing");
import VueMeta from "vue-meta";
import VueCookies from "vue-cookies";

import firebase from "firebase/app";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAX4LQzGy9Ge8qXbGhzDSqwpHvQtmYd89o",
  authDomain: "viewmed-web.firebaseapp.com",
  projectId: "viewmed-web",
  storageBucket: "viewmed-web.appspot.com",
  messagingSenderId: "640005556280",
  appId: "1:640005556280:web:4a98e3db3018dfb893fecd",
  measurementId: "G-EZ3Y3ZF30X",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore(app); // Use 'app' argument
const auth = firebase.auth(app);
const storage = firebase.storage(app);
firebase.analytics();

Vue.use(VueCookies);
Vue.$cookies.config("7d");

Vue.config.productionTip = false;
Vue.use(VueMaterial);
Vue.use(Vuelidate);
Vue.use(Vuetify, {
  theme: {
    institution: "#8e24aa",
    physician: "#0277bd",
    patient: "#00a887",
    system: "#6d8110",
  },
});
Vue.use(SocialSharing);
Vue.use(VueFullPage);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAOBM5oRMaTfWNQ_W2u0wlYoh1l3-lxtMg",
    libraries: "places",
  },
});

Vue.use(VueTheMask);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
fontawesome.library.add(brands, regular, solid);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("vueDropzone", vue2Dropzone);
Vue.use(VueCarousel);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>",
});

export { firestore, auth, storage };



// WEBPACK FOOTER //
// ./src/main.js